/* eslint-disable react/jsx-no-undef */
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Typography } from '@mui/material';
import {
  AUDITING__FIELD_NAME,
  AUDITING__FIELD_NEW_VALUE,
  AUDITING__FIELD_OLD_VALUE,
  AUDITING__USER_CREATED,
  AUDITING__USER_MODIFIED,
} from 'translations/constants';
import { AuditModel } from './types';

const formatDate = (d: Date | string) => {
  const date = d instanceof Date ? d : new Date(d);
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const AuditRow: React.FC<{ audit: AuditModel }> = ({ audit }) => {
  const [t] = useTranslation();

  return (
    <TableRow hover>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{audit.author}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(audit.changeDate)}</TableCell>
      <TableCell sx={{ pr: 0 }}>
        <Typography variant="body2" fontWeight={600} gutterBottom>
          {audit.changes.length ? t(AUDITING__USER_MODIFIED) : t(AUDITING__USER_CREATED)}
        </Typography>
        {audit.changes.map(c => (
          <Typography variant="body2" color="text.secondary" noWrap>
            {`${t(AUDITING__FIELD_NAME)} '${c.propertyName}': ${t(AUDITING__FIELD_OLD_VALUE)}: "${c.oldValue}" → ${t(
              AUDITING__FIELD_NEW_VALUE,
            )}: "${c.newValue}"`}
          </Typography>
        ))}
      </TableCell>
      <TableCell align="right" width={56} />
    </TableRow>
  );
};
